import * as React from 'react'
import { cn } from '../../lib/utils'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, style, disabled, ...props }, ref) => {
    const resolvedBackground =
      style?.backgroundColor ??
      (disabled ? 'var(--input-disabled-bg, #f4f4f5)' : 'white')

    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-input px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-neutral-400 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield] my-2 font-normal text-neutral-600 pb-2 mt-0 mb-0',
          className,
        )}
        style={{ ...style, backgroundColor: resolvedBackground }}
        disabled={disabled}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
